import { render } from "./list-bloques-home.vue?vue&type=template&id=0e423f91"
import script from "./list-bloques-home.vue?vue&type=script&lang=js"
export * from "./list-bloques-home.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__